import { useHistory, useRouteMatch } from 'react-router-dom';

import {
  Button,
  StaleContainer,
  StaleParagraphMedium,
  StaleParagraphBold,
  StaleSubTitleBold,
  StaleNotification,
  StaleHexagonList,
  ButtonSecondary,
  StaleOverflowScroll,
} from 'components';

import { MainContent } from './Main.styles';

const Main = () => {
  const history = useHistory();
  const { url } = useRouteMatch();

  return (
    <>
      <MainContent className="signup-company">
        <StaleOverflowScroll>
          <StaleContainer>
            <StaleNotification
              title="You are halfway there!"
              cross={false}
              icon="look-smile"
              bgColor="#121213"
            >
              <StaleParagraphMedium>
                Now you have limited access to HedgeFlows platform.
              </StaleParagraphMedium>
            </StaleNotification>

            <StaleSubTitleBold>
              Here’s what you need to complete the application and get full
              access to HedgeFlows
            </StaleSubTitleBold>

            <StaleHexagonList color="#121213">
              <li>
                <svg>
                  <use xlinkHref="#star-ico" />
                </svg>
                <StaleParagraphBold>Your business info</StaleParagraphBold>
                The nature of your business, annual turnover and so on
              </li>
              <li>
                <svg>
                  <use xlinkHref="#star-ico" />
                </svg>
                <StaleParagraphBold>Your company details</StaleParagraphBold>
                Details about it’s registration, owners contact info, VAT
              </li>
              <li>
                <svg>
                  <use xlinkHref="#star-ico" />
                </svg>
                <StaleParagraphBold>eID Verification</StaleParagraphBold>
                Please make sure you have one of your documents with you
              </li>
              <li>
                <svg>
                  <use xlinkHref="#star-ico" />
                </svg>
                <StaleParagraphBold>Proof of Funds</StaleParagraphBold>
                Be rady to answer couple of questions
              </li>
              <li>
                <svg>
                  <use xlinkHref="#star-ico" />
                </svg>
                <StaleParagraphBold>Done!</StaleParagraphBold>
                We will let you know of the results of the registration right
                away
              </li>
            </StaleHexagonList>
          </StaleContainer>
        </StaleOverflowScroll>
      </MainContent>

      <div className="btns-group">
        <Button onClick={() => history.push(`${url}?step=1`)}>Continue</Button>

        <ButtonSecondary onClick={() => history.push('/app/dashboard')}>
          Skip for now
        </ButtonSecondary>
      </div>
    </>
  );
};

export default Main;
